import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import '@deere/ux.uxframe-core/dist/css/uxframe-2019.3.0.min.css';
import {Container, Row, Col} from '@deere/ux.uxframe-react';

import RegistrationRequest from './views/screens/RegistrationRequest'
import AdminRequest from './views/screens/AdminRequest';

import CustomSideNav from './views/shared/CustomSideNav';
import CUTFooter from './views/CUTFooter';
import CUTHeader from './views/CUTHeader';
import RegistrationSuccess from "./views/screens/RegistrationSuccess";

import "./App.css"

function App() {
    const [mobileMenu, setMobileMenu] = useState(false);

    const closeNavbar = () =>{
        if(window.innerWidth < 768){
            setMobileMenu(true)
        } else {
            setMobileMenu(false)
        }
    }

    window.addEventListener("resize", closeNavbar)

    useEffect(() =>{
        closeNavbar()
    },[])

    return (
        <div className="app-container-root mx-auto">
            <Router>
                <CUTHeader mobileMenu={mobileMenu}/>
                <Container className="app-container">
                    <Row>
                        {!mobileMenu ? (<Col className="app-content-col col-6 col-sm-6 col-md-6 col-lg-6" style={{width:'33%'}}>
                            <CustomSideNav mobileMenu={mobileMenu}/>
                        </Col>) : null}
                        <Col className="app-content-col-main-content `${ !mobileMenu ? col-18 col-sm-18 col-md-18 col-lg-18 : col-24 col-sm-24 col-md-24 col-lg-24}`" >
                            <Switch>
                                <Route exact path="/" component={RegistrationRequest} mobileMenu={mobileMenu}/>
                                <Route path="/CutReg/admin" component={AdminRequest} mobileMenu={mobileMenu}/>
                                <Route path = "/regSuccess" component = {RegistrationSuccess} mobileMenu={mobileMenu}/>
                            </Switch>
                        </Col>
                    </Row>
                </Container>
                <CUTFooter/>
            </Router>
        </div>
    );
}

export default App;
